import React from "react";
import { Routes, Route } from "react-router-dom";
import ListKiosk from "../Components/Kiosk/kioskList";
import ViewKiosk from "../Components/Kiosk/kioskView";

const KioskRoutes = () => {
  return (
    <Routes>
      <Route
        path="/kiosk"
        element={<ListKiosk></ListKiosk>}
      ></Route>
      <Route path="/kiosk/view/:id" element={<ViewKiosk> </ViewKiosk>}></Route>
    </Routes>
  );
};

export default KioskRoutes;
